var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsersSolid = function SvgUsersSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M12.85 15.284a.625.625 0 0 1-.524.966H.799a.625.625 0 0 1-.523-.966 7.5 7.5 0 0 1 3.689-2.947 4.687 4.687 0 1 1 5.195 0 7.5 7.5 0 0 1 3.69 2.947m6.867-.012a7.5 7.5 0 0 0-3.682-2.935 4.688 4.688 0 0 0-4.73-8.072.313.313 0 0 0-.104.469 5.92 5.92 0 0 1 .283 7.026.313.313 0 0 0 .084.432 8.8 8.8 0 0 1 2.332 2.409c.248.38.35.837.285 1.286a.315.315 0 0 0 .178.334.3.3 0 0 0 .13.029h4.712a.624.624 0 0 0 .604-.463.64.64 0 0 0-.092-.515"
  })));
};
export default SvgUsersSolid;